import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import playlistKeys from './queryKeys';
import contentKeys from 'actions/content/queryKeys';
function useAddPlaylist(ownerTeamId, options) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function addPlaylist(_x) {
    return _addPlaylist.apply(this, arguments);
  }
  function _addPlaylist() {
    _addPlaylist = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(playlistData) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('post', '/api/playlists', null, playlistData));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _addPlaylist.apply(this, arguments);
  }
  var _useMutation = useMutation(_objectSpread(_objectSpread({
      mutationFn: addPlaylist
    }, options), {}, {
      onSuccess: function onSuccess() {
        if (ownerTeamId) {
          queryClient.invalidateQueries({
            queryKey: playlistKeys.playlists(ownerTeamId)
          });
        }
        queryClient.invalidateQueries({
          queryKey: playlistKeys.playlistList()
        });
        queryClient.invalidateQueries({
          queryKey: contentKeys.contentLogs()
        });
        setSuccessAlert({
          title: t('alert_playlist_added_successfully')
        });
      },
      onError: function onError() {
        setAlert({
          title: t('alert_playlist_not_added')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded);
  return _objectSpread(_objectSpread({}, result), {}, {
    addPlaylist: mutateAsync
  });
}
export default useAddPlaylist;